import axios from 'axios'

const checkIsPurchasable = async ({ handle, quantity }) => {
  const data = await axios.get(`/products/${handle}?view=ajax`)
  const { productStatus, limit, cartQuantity } = data.data

  // 売り切れ
  if (productStatus === 'soldout') throw new Error('SOLD OUT')

  // 入荷待ち
  if (productStatus === 'backstock') throw new Error('入荷待ちです')

  // 購入限定数を超えていないか
  if (limit > 0 && cartQuantity + quantity > limit)
    throw new Error('購入可能な上限数を超えています')
}

export const addToCart = async (items) => {
  const itemsAddFailed = []

  const itemsPurchasable = await Promise.all(
    items.map(async (item) => {
      try {
        await checkIsPurchasable(item)
        return item
      } catch (error) {
        itemsAddFailed.push({
          ...item,
          addFailedReason: error.message,
        })
      }
    })
  )
  if (itemsPurchasable.filter((v) => v).length === 0)
    return { itemsAddFailed, itemsAdded: [] }

  return await axios
    .post('/cart/add.js', { items: itemsPurchasable })
    .then((response) => {
      // モーダル表示、カートアイコンバッジ更新
      const itemsAdded = response.data.items.map((item) => {
        const itemAdded = itemsPurchasable.find((i) => i?.id == item.id) || {}
        return {
          ...itemAdded,
          addedQuantity: itemAdded?.quantity || 0,
          id: item.product_id,
          image: item.image,
          productTitle: item.product_title,
          productType: item.product_type,
          price: item.price / 100,
          variant: item.id,
          vendor: item.vendor,
        }
      })
      return { itemsAdded, itemsAddFailed }
    })
    .catch((error) => {
      console.error('Error adding items to cart:', error)
      alert('カートにアイテムを追加できませんでした。')
    })
}
